// import moment from "moment/moment";
import { POST, PUT, SUCCESS } from "../utils/const/http-const";
import { getHeaders } from "./utils";

export async function obtenerAlertaChecklist(obj) {
    try {
        let data = null;
        const { code, body } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/alerta-checklist/obtener-alerta-checklist",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (code === SUCCESS && Array.isArray(body) && body.length > 0) {
            data = body[0];
        }
        return data;
    } catch (err) {
        console.log("obtenerAlertaChecklist err");
        console.log(err);
        return null;
    }
}

export async function crearAlertaChecklist(obj) {
    try {
        let creado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/alerta-checklist/guardar-alerta-checklist/",
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            creado = true;
        }
        return creado;
    } catch (err) {
        console.log("crearAlertaChecklist err");
        console.log(err);
        return false;
    }
}

export async function modificarAlertaChecklist(obj) {
    try {
        let modificado = false;
        const { code } = await fetch(
            "https://gestiondeflota.boltrack.net/apichecklistv2/api/alerta-checklist/modificar-alerta-checklist/",
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        // console.log('code');
        // console.log(code);
        // console.log('body');
        // console.log(body);
        if (code === SUCCESS) {
            modificado = true;
        }
        return modificado;
    } catch (err) {
        console.log("modificarAlertaChecklist err");
        console.log(err);
        return false;
    }
}
